import { requestDeduplicator } from '@shared/util'
import axios, { Method } from 'axios'
import uniqid from 'uniqid'
import { axiosRefreshToken } from './axios-refresh-token'

const authorizedApiClient = axios.create()
axiosRefreshToken(authorizedApiClient)

export const makeRequest = async <P = undefined>(url: string, method: Method, params?: P): Promise<any> => {
  return requestDeduplicator.deduplicateRequest(
    url,
    method,
    async () => {
      const token = localStorage.getItem('token')
      const headers: Record<string, string> = {}
      if (token) {
        headers.authorization = `Bearer ${token}`
      }

      if (url.includes(import.meta.env.VITE_API_URL)) {
        const id = uniqid()
        headers['sentry-trace'] = id
      }
      const fetchRequest = await authorizedApiClient(url, {
        method,
        headers,
        data: params ?? undefined,
      })

      return fetchRequest.data
    },
    params,
  )
}

export const makePublicRequest = async <P = undefined>(url: string, method: Method, params?: P): Promise<any> => {
  return requestDeduplicator.deduplicateRequest(
    url,
    method,
    async () => {
      const fetchRequest = await axios(url, {
        method,
        data: params ?? undefined,
      })

      return fetchRequest.data
    },
    params,
  )
}
